import { LatestTransactionsTableTranslations } from ".";

export const LATEST_TRANSACTIONS_TABLE_FR_FR: LatestTransactionsTableTranslations = {
	title: "Derniers retraits et anticipations",
	date: "Date de la demande",
	paymentDate: "Date de paiement",
	status: "Statut",
	type: "Type",
	value: "Valeur",
	actions: "Actions",
	requester: "Demandeur",
	refused: "Refusé",
	pending: "En attente",
	canceled: "Annulé",
	paid: "Payé",
	processingCancellation: "Traitement de l'annulation",
	processing: "En cours de traitement",
	pixProcessing: "Traitement PIX",
	bankslipProcessing: "Traitement du Billet",
	pendingManagerApproval: "En attente d'approbation du gestionnaire",
	pendingPlaceConfirmation: "En attente de confirmation du place",
	canceledPlaceConfirmation: "Confirmation du place annulée",
	pendingAnticipation: "En attente d'anticipation",
	pendingTreasuryAction: "En attente d'action de la ZIG",
	prorata: "Pro rata",
	pixKey: "Clé PIX",
	reason: "Raison",
	requestReason: "Motif",
	refusalReason: "Motif du refus",
	favorecido: "Bénéficiaire",
	dataInicial: "Date de début",
	dataFinal: "Date de fin",
	at: "à",
	contaPropria: "Compte propre",
	placeDestino: "Place de destination",
	beneficiarioBoleto: "Bénéficiaire du billet",
	back: "Retour",
	withdrawal: "Retrait",
	anticipation: "Anticipation",
	detailsTitle: "Détails de la transaction",
	filename: "retraits-anticipations-billets",
	// Nouveaux champs pour compte bancaire
	accountHolder: "Titulaire du Compte",
	accountType: "Type de Compte",
	agency: "Agence",
	account: "Compte",
	bankName: "Nom de la Banque",
	accountName: "Nom du Compte",
	cancelWithdraw: "Annuler le retrait",
	viewDetails: "Voir les détails",
	cancelConfirmTitle: "Annuler le retrait",
	cancelConfirmDescription:
		"Êtes-vous sûr de vouloir annuler ce retrait ? Cette action ne peut pas être annulée.",
	confirmCancel: "Oui, annuler",
	internalObservation: "Observations",
	table: {
		datetime: "Date de la demande",
		paymentDate: "Date de paiement",
		type: "Type",
		status: "Statut",
		username: "Utilisateur",
		vendor: "Fournisseur",
		requestedValue: "Montant demandé",
		liquidAnticipatedValue: "Montant anticipé",
		proRataFee: "Pro rata",
		appliedFee: "Frais appliqué",
		proRataFeeTooltip:
			"Frais d'anticipation proportionnels à la période du solde à anticiper",
		totalBruteValue: "Valeur brute totale",
		bankAccount: "Compte bancaire",
		ticketPayment: "Paiement par billet",
		clientObservation: "Motif",
		obs: "Observation",
		paymentMethod: "Méthode de paiement",
		attachments: "Pièces jointes",
		confirmWithdrawBtnLabel: "Confirmer la demande",
	},
	transactionLink: "Lien de transaction",
	filterByType: "Filtrer par type",
	allTypes: "Tous les types",
	typeWithdraw: "Retrait",
	typeAnticipation: "Anticipation",
	typeTicketPayment: "Paiement par billet",
	typeTransferBetweenPlaces: "Transfert entre Places",
	// Traductions pour les retraits refusés et liés
	viewOriginalWithdraw: "Voir le retrait original",
	viewNewWithdraw: "Voir le nouveau retrait",
	originalWithdrawRequest: "Demande Originale",
	newWithdrawRequest: "Nouvelle Demande",
	withdrawDeclinedTitle: "Retrait Refusé en Raison d'un Solde Insuffisant",
	withdrawDeclinedMessage:
		"Ce retrait a été automatiquement refusé car le solde disponible était insuffisant au moment de l'approbation. Si le montant en compte est supérieur à R$ 50,00, nous ferons une nouvelle demande.",
	thisIsNewWithdraw:
		"Ceci est le nouveau retrait créé après le refus du retrait original.",
	thisIsDeclinedWithdraw: "Ce retrait a été refusé et un nouveau retrait a été créé.",
	retryPixReceipt: "Générer nouveau reçu",
	retryPixReceiptSuccess: "Reçu généré avec succès !",
	retryPixReceiptError: "Erreur lors de la génération du nouveau reçu",
	receiptNotAvailable: "Reçu non disponible",
};
